import React, { Component } from 'react';
import {
   Modal,
   Fade,
   Grid,
   Typography,
   IconButton,
   Button,
   TextField,
   InputAdornment,
   FormControl
} from '@mui/material';
import {
   Visibility,
   VisibilityOff,
   Lock as LockIcon,
   Close as CloseIcon
} from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import { IoClose } from 'react-icons/io5';
import paths from '../../../paths.json';
import get_and_post_data_skeleton from '../../common/common/get_and_post_data_skeleton';
import Loader from '../../common/Loader';
const FormInput = styled(TextField)({
   '& .MuiOutlinedInput-root': {
      '& fieldset': {
         borderColor: '#A2A2A2',
      },
      '&:hover fieldset': {
         borderColor: '#C6C6C6',
      },
      '&.Mui-focused fieldset': {
         borderColor: '#C6C6C6',
      },
   },
   '& .MuiFilledInput-root': {
      display: 'flex',
      alignItems: 'center',
      height: '50px',
      paddingRight: '14px',
   },
   '& .MuiFilledInput-input': {
      padding: '8px 0',
   }
});


class PasswordUpdatePopup extends Component {
   constructor(props) {
      super(props);
      this.state = {
         errorMsg: "",
         current_password: "",
         new_password: "",
         show_current_password: false,
         show_new_password: false,
         loading: false
      };
   }

   handleCurrentPassword = (event) => {
      this.setState({ current_password: event.target.value });
   }

   handleChangePassword = (event) => {
      this.setState({ new_password: event.target.value });
   }

   handleClickShowCurrentPassword = () => {
      this.setState(prev => ({ show_current_password: !prev.show_current_password }));
   }

   handleClickShowNewPassword = () => {
      this.setState(prev => ({ show_new_password: !prev.show_new_password }));
   }

   validatePassword = (currentPassword, newPassword) => {
      if (newPassword === currentPassword) {
         this.setState({
            errorMsg: "New password cannot be the same as previous passwords",
         });
         return false;
      }
      return true;
   }

   verifyPassword = (newPassword) => {
      const regex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d@$!%*#?&^_-]{8,}$/;
      if (!newPassword || regex.test(newPassword) === false) {
         this.setState({
            errorMsg: "Password must contain at least 8 characters, an uppercase letter, a lowercase letter, a special character and a number"
         });
         return false;
      }
      return true;
   }

   UpdatePassword = (event) => {
      if (this.validatePassword(this.state.current_password, this.state.new_password) === true) {
         if (this.verifyPassword(this.state.new_password) === true) {
            event.preventDefault();
            this.setState({ loading: true });
            const form_data = new FormData();
            form_data.append('current_password', this.state.current_password);
            form_data.append('new_password', this.state.new_password);
            get_and_post_data_skeleton(
               paths.BACKEND_URL + 'api/update_password_loggedin',
               'post',
               false,
               form_data,
               this.UpdatePasswordPost,
               false,
               false,
               () => this.setState({ loading: false })
            );
         }
      }
   }

   UpdatePasswordPost = (res) => {
      this.setState({ loading: false });
      if (res.data.error) {
         if (res.data.error === 'current_password_incorrect') {
            this.setState({
               errorMsg: "Current password incorrect",
            });
         } else if (res.data.error === 'new_passwords_do_not_match') {
            this.setState({
               errorMsg: "New passwords do not match"
            });
         } else {
            this.setState({
               errorMsg: "Error, please try again"
            });
         }
      } else {
         this.props.show_password_complete_snackbar();
         this.props.close_updating_password();
         this.setState({
            errorMsg: "",
            current_password: "",
            new_password: "",
            show_current_password: false,
            show_new_password: false,
         })
      }
   }

   render() {
      return (
         <Modal
            disableAutoFocus={true}
            open={this.props.updating_password}
            sx={{
               backgroundColor: 'rgba(0,0,0,0.47)', 
               borderRadius: '5px',
               overflow: 'scroll',
               minWidth: '100vw',
               outline: '0',
               display: 'flex',
               zIndex: '1100',
               lineHeight: '25px',
               textAlign: 'center',
               maxHeight: '100vh',
               minHeight: '100vh',
            }}
         >
            <Grid sx={{
               height: 'auto',
               borderRadius: window.innerWidth <= 600 ? '0px' : '5px',
               margin: 'auto',
               textAlign: 'center',
               display: 'flex'
            }} xs={12} justifyContent='center' textAlign='center'>
               <Grid container xs={12} alignItems="center" justifyContent="center" direction="column" style={{
                  width: '100%',
                  display: 'flex',
                  borderRadius: window.innerWidth <= 600 ? '0px' : '5px',
               }}>
                  <Grid sx={{
                     width: '100vw',
                     maxWidth: '600px',
                     height: 'auto',
                     backgroundColor: '#fff',
                     borderRadius: window.innerWidth <= 600 ? '0px' : '10px',
                     margin: 'auto',
                     boxShadow: '0 5px 25px 0 rgba(35, 40, 105, 0.04)',
                  }}>
                     <Grid item xs={6} style={{
                        top: '0px',
                        padding: '0px',
                        float: 'right',
                        paddingRight: '2%',
                        paddingTop: '2%',
                        textAlign: 'right',
                        flexBasis: '33%',
                     }}>
                        <IconButton style={{
                           padding: '0px',
                           margin: '0px',
                           textAlign: 'right',
                           color: '#9CA3B4',
                           backgroundColor: 'transparent',
                           justifyContent: 'right',
                           minWidth: '30px',
                        }} onClick={this.props.close_updating_password}>
                           <IoClose style={{
                              fontSize: '30px',
                              fontWeight: '300',
                              textAlign: 'right',
                              display: 'flex',
                              position: 'absolute',
                              padding: '0px',
                           }} />
                        </IconButton>
                     </Grid>

                     <Grid container xs={12} style={{
                        padding: '0px',
                        height: '30px',
                        paddingTop: '20px',
                        borderRadius: '0px',
                        backgroundColor: '#fff',
                        borderTopLeftRadius: '5px',
                        borderTopRightRadius: '5px',
                        flexWrap: 'nowrap'
                     }}>
                        <Grid item xs={12} style={{ alignSelf: 'center', textAlign: 'center', marginBottom: '10px' }}>
                        <p style={{ fontSize: '20px', margin: '0px 0px 0px 0px', fontWeight: '600', fontFamily: 'Roboto' }}>Update Password</p>
                        <p style={{ fontSize: '14px', margin: '5px 0px 0px 0px', color: '#6E89AF', fontWeight: '500', fontFamily: 'Roboto' }}>
                            Protect your account with a strong password
                        </p>
                        </Grid>
                     </Grid>

                     <Grid xs={12} style={{ padding: '20px', textAlign: 'center', marginTop: '20px' }}>
                        <FormControl fullWidth hiddenLabel variant="filled" sx={{
                           backgroundColor: '#fff',
                           border: '0px',
                           marginTop: '0px',
                           borderRadius: '5px',
                           display: 'block',
                           textAlign: 'center',
                        }}>
                           <FormInput
                              fullWidth
                              size="small"
                              variant="filled"
                              placeholder="Current Password"
                              value={this.state.current_password}
                              onChange={this.handleCurrentPassword}
                              type={this.state.show_current_password ? 'text' : 'password'}
                              autoComplete='off'
                              InputProps={{
                                 disableUnderline: true,
                                 sx: {
                                    fontSize: 18,
                                    fontWeight: 600,
                                    color: 'var(--light-theme-text-color)',
                                 },
                                 startAdornment: (
                                    <InputAdornment sx={{marginRight: '10px'}}>
                                       <LockIcon sx={{ color: 'var(--light-theme-text-color)' }} />
                                    </InputAdornment>
                                 ),
                                 endAdornment: (
                                    <InputAdornment sx={{marginLeft: '5px'}}>
                                       <IconButton
                                          onClick={this.handleClickShowCurrentPassword}
                                          edge="end"
                                       >
                                          {this.state.show_current_password ?
                                             <Visibility sx={{ color: 'var(--light-theme-text-color)' }} /> :
                                             <VisibilityOff sx={{ color: 'var(--light-theme-text-color)' }} />
                                          }
                                       </IconButton>
                                    </InputAdornment>
                                 )
                              }}
                              sx={{
                                 mb: 2,
                                 width: '100%',
                                 mx: 'auto',
                                 display: 'block',
                                 flex: 1
                              }}
                           />

                           <FormInput
                              fullWidth
                              size="small"
                              variant="filled"
                              placeholder="New Password"
                              value={this.state.new_password}
                              onChange={this.handleChangePassword}
                              type={this.state.show_new_password ? 'text' : 'password'}
                              autoComplete='off'
                              InputProps={{
                                 disableUnderline: true,
                                 sx: {
                                    fontSize: 18,
                                    fontWeight: 600,
                                    color: 'var(--light-theme-text-color)'
                                 },
                                 startAdornment: (
                                    <InputAdornment sx={{marginRight: '5px'}}>
                                       <LockIcon sx={{ color: 'var(--light-theme-text-color)' }} />
                                    </InputAdornment>
                                 ),
                                 endAdornment: (
                                    <InputAdornment sx={{marginLeft: '10px'}}>
                                       <IconButton
                                          onClick={this.handleClickShowNewPassword}
                                          edge="end"
                                       >
                                          {this.state.show_new_password ?
                                             <Visibility sx={{ color: 'var(--light-theme-text-color)' }} /> :
                                             <VisibilityOff sx={{ color: 'var(--light-theme-text-color)' }} />
                                          }
                                       </IconButton>
                                    </InputAdornment>
                                 )
                              }}
                              sx={{
                                 width: '100%',
                                 mx: 'auto',
                                 display: 'block'
                              }}
                           />

                           <Typography
                              color="error"
                              sx={{
                                 textAlign: 'center',
                                 mt: 2
                              }}
                           >
                              {this.state.errorMsg}
                           </Typography>

                           <Button
                              disableRipple
                              fullWidth
                              variant="contained"
                              onClick={this.UpdatePassword}
                              sx={{
                                 backgroundColor: 'var(--brand-color)',
                                 fontSize: '16px',
                                 marginTop: '20px',
                                 textTransform: 'none',
                                 marginBottom: '0px',
                                 borderRadius: '8px',
                                 boxShadow: 'none',
                                 fontWeight: '700',
                                 ':hover': {
                                    backgroundColor: 'var(--brand-color-hover)',
                                    color: 'white',
                                    boxShadow: 'none',
                                 },
                              }}
                           >
                              Update Password
                           </Button>
                        </FormControl>
                     </Grid>
                  </Grid>
               </Grid>
               <Loader loading={this.state.loading} style={{ width: "100%" }} />
            </Grid>
         </Modal>
      );
   }
}

export default PasswordUpdatePopup;